import React, { useState, useEffect } from 'react';
import Toast from '@applane/react-toast';
import { cancelButton, save } from '../../app-components';
import { emailIcon, messageIcon, printerIcon } from '../../images';
import { IconButton } from '../../app-components/buttons/Buttons';
import { invoke } from '../../AppServices';
import '../Welcome/loader.css'
import { Saving } from '../../app-components/action/SaveAction';
import { CancelButton } from '../../app-components/action/CloseAction';


const ViewButtonsLists = ({ id, setView, avgen }) => {
    console.log('viewButtonsList');
  
  
    const renderPrintButton = () => (
      <IconButton
        onClick={async () => {
          window.print();
          const result = await invoke({ id: 'appraisalResultPrint', paramValue: { appraisalId: id } });
          // Handle result as needed
        }}
        description="Print"
        tooltipId="printer-icon"
        style={{ usingIcon: true }}
        icon={printerIcon}
        iconStyle={{ height: 20, width: 20 }}
        stylelg={{ paddingLeft: 0, paddingRight: 0 }}
        labelStyle={{ fontSize: 18, color: '#ffffff', fontFamily: 'Mulish-SemiBold' }}
      />
    );
  
    const renderSendMessageButton = () => (
      <IconButton
        onClick={async () => {
          const fromBack = await invoke({ id: 'appraisalResultMessage', paramValue: { appraisalId: id } });
          if (fromBack.result) {
            Toast.show(fromBack.result);
          } else {
            Toast.show({
              message: fromBack.responseMessage,
              type: 'warning',
              position: 'top',
              direction: 'left',
            });
          }
        }}
        description="Send Message"
        tooltipId="appraisal-generated-send-message"
        style={{ usingIcon: true,   }}
        icon={messageIcon}
        iconStyle={{ height: 20, width: 20 }}
        stylelg={{ paddingLeft: 0, paddingRight: 0 }}
        labelStyle={{ fontSize: 18, color: '#ffffff', fontFamily: 'Mulish-SemiBold' }}
      />
    );
  
    const renderSendEmailButton = () => (
      <IconButton
        onClick={async () => {
          const mailResultFromBack = await invoke({ id: 'sendAppraisalResultMail', paramValue: { appraisalId: id } });
  
          if (mailResultFromBack.statusCode === 202) {
            await invoke({ id: 'updateMailOfferCountAndOfferList', paramValue: { appraisalId: id } });
            Toast.show({
              message: 'Success',
              description: 'Email Sent.',
              type: 'success',
              position: 'top',
              direction: 'left',
            });
          } else {
            Toast.show({
              message: mailResultFromBack.responseMessage,
              type: 'warning',
              position: 'top',
              direction: 'left',
            });
          }
        }}
        description="Send Email"
        tooltipId="appraisal-generated-send-email"
        style={{ usingIcon: true }}
        icon={emailIcon}
        iconStyle={{ height: 20, width: 20 }}
        stylelg={{ paddingLeft: 0, paddingRight: 0 }}
        labelStyle={{ fontSize: 18, color: '#ffffff', fontFamily: 'Mulish-SemiBold' }}
      />
    );
  
    return (
      <div className='d-flex'>
        <div className='me-3' onClick={()=>setView(false)}>
        <CancelButton />
        </div>
        <Saving />
        {avgen && (
          <>
            {renderPrintButton()}
            <div style={{paddingLeft: '8px', paddingRight: '8px'}}>
              {renderSendMessageButton()}
            </div>
            {renderSendEmailButton()}
          </>
        )}
      </div>
    );
  };
  
  export default ViewButtonsLists;